export enum AuthHeaders {
  XAuthToken = 'X-Auth-Token'
}
